import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {  emailValidator,  mustMatch } from "../utils/app-validators";
import Swal from 'sweetalert2'
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  public form: FormGroup;
  error: string;
  public submitted = false;
  public id
  spinnerType = SPINNER.circle;
  loading = false;
  fieldTextType = false
  confirmFieldTextType = false
  constructor(private ngxService: NgxUiLoaderService, public router: Router, public fb: FormBuilder, public authenticationService: AuthenticationService) {
   }

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        email: [null, [Validators.required, Validators.email]],
        password: [null, [Validators.required, Validators.minLength(6)]],
        confirmPassword: [null, Validators.required],
      },
      {
        validator: mustMatch('password', 'confirmPassword')
    }
    );
}
get f() { return this.form.controls;}


toggleFieldTextType(key) {
  if(key == 'password')this.fieldTextType = !this.fieldTextType;
  if(key == 'confirmPassword')this.confirmFieldTextType = !this.confirmFieldTextType
}




onSubmit(values: Object): void {
  this.submitted = true;
        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }
  if (this.form.valid) {
    let email = this.form.get('email').value
    let password = this.form.get('password').value
    let deviceType = "web";
    let version = "1";
    let role = "Merchant";
    let obj = {email: email, password: password, deviceType: deviceType, version: version, role: role}
    this.ngxService.start();
    this.authenticationService.signUp(obj).subscribe(
      data => {
        this.ngxService.stop();
        let user = data;
        const helper = new JwtHelperService();
        const decodedToken = helper.decodeToken(user.token);
        let info =  {email: this.form.get('email').value, name: ''}
        localStorage.setItem('merchant_user', JSON.stringify(info));
        localStorage.setItem('email', this.form.get('email').value)
        this.router.navigate(["/user-registration"]);
        this.authenticationService.setIsProfileUpdate(false);
        Swal.fire(
          "",
           "Please complete your registration.",
          "success"
        );
        this.onReset();
      },
      error => {
        this.ngxService.stop();
        console.log(error.error, 'testing')
        if (error) {
          if(error.error.error) {
            Swal.fire(
              "Error",
              error.error.message,
              "error"
            );
          }

        }
      }
    );
  }
}
onReset() {
  this.submitted = false;
  this.form.reset();
}
}
